const environmentConfig = {
  local: {
    BASE_URL: 'http://localhost:7001/',
    STORE_FINDER_BASE_URL: 'https://api.morrisons.com/',
    API_KEY: '6KGJeMru0wuocaeEZCyToIuD4vvxl09H',
    STORE_FINDER_API_KEY: 'kxBdM2chFwZjNvG2PwnSn3sj6C53dLEY',
    BING_MAP_KEY:
      'Ag00iheqslugEVbwF43XtJCoY0tAUdcyXd8XS3oA4l389lpCxFj2vYXknu_B_0ua',
    LOCKER_TOKEN: 'JMA71498124dN3_9133-84175FUDA446238',
  },
  dev: {
    BASE_URL: 'https://dev-api.morrisons.com/',
    STORE_FINDER_BASE_URL: 'https://api.morrisons.com/',
    API_KEY: '6KGJeMru0wuocaeEZCyToIuD4vvxl09H',
    STORE_FINDER_API_KEY: 'kxBdM2chFwZjNvG2PwnSn3sj6C53dLEY',
    BING_MAP_KEY:
      'Ag00iheqslugEVbwF43XtJCoY0tAUdcyXd8XS3oA4l389lpCxFj2vYXknu_B_0ua',
    LOCKER_TOKEN: 'JMA71498124dN3_9133-84175FUDA446238',
  },
  uat: {
    BASE_URL: 'https://dev-api.morrisons.com/',
    STORE_FINDER_BASE_URL: 'https://api.morrisons.com/',
    API_KEY: '6KGJeMru0wuocaeEZCyToIuD4vvxl09H',
    STORE_FINDER_API_KEY: 'kxBdM2chFwZjNvG2PwnSn3sj6C53dLEY',
    BING_MAP_KEY:
      'Ag00iheqslugEVbwF43XtJCoY0tAUdcyXd8XS3oA4l389lpCxFj2vYXknu_B_0ua',
    LOCKER_TOKEN: 'JMA71498124dN3_9133-84175FUDA446238',
  },
  pre: {
    BASE_URL: 'https://api.morrisons.com/',
    STORE_FINDER_BASE_URL: 'https://api.morrisons.com/',
    API_KEY: 'ncGtQs6JP1AqXYQGtMW3ofWyA0Q4IvzR',
    STORE_FINDER_API_KEY: 'kxBdM2chFwZjNvG2PwnSn3sj6C53dLEY',
    BING_MAP_KEY:
      'Ag00iheqslugEVbwF43XtJCoY0tAUdcyXd8XS3oA4l389lpCxFj2vYXknu_B_0ua',
    LOCKER_TOKEN: 'AUsj9huqdrGZNCVUC9eXMC3byY5kJP*84wfW',
  },
  prod: {
    BASE_URL: 'https://api.morrisons.com/',
    STORE_FINDER_BASE_URL: 'https://api.morrisons.com/',
    API_KEY: 'ncGtQs6JP1AqXYQGtMW3ofWyA0Q4IvzR',
    STORE_FINDER_API_KEY: 'kxBdM2chFwZjNvG2PwnSn3sj6C53dLEY',
    BING_MAP_KEY:
      'Ag00iheqslugEVbwF43XtJCoY0tAUdcyXd8XS3oA4l389lpCxFj2vYXknu_B_0ua',
    LOCKER_TOKEN: 'AUsj9huqdrGZNCVUC9eXMC3byY5kJP*84wfW',
  },
  now: {
    BASE_URL: '/',
    STORE_FINDER_BASE_URL: 'https://api.morrisons.com/',
    API_KEY: '6KGJeMru0wuocaeEZCyToIuD4vvxl09H',
    STORE_FINDER_API_KEY: 'kxBdM2chFwZjNvG2PwnSn3sj6C53dLEY',
    BING_MAP_KEY:
      'Ag00iheqslugEVbwF43XtJCoY0tAUdcyXd8XS3oA4l389lpCxFj2vYXknu_B_0ua',
    LOCKER_TOKEN: 'AUsj9huqdrGZNCVUC9eXMC3byY5kJP*84wfW',
  },
}

export default environmentConfig[process.env.REACT_APP_ENV]
